import { useEffect, useState } from 'react';

// Lightweight "app visit" streak — counts consecutive days the user
// opened the web app. Stored locally (per browser) so it works for
// guests and authed users alike.
const KEY = 'today_visit_streak';

function todayStr() {
  return new Date().toISOString().slice(0, 10); // YYYY-MM-DD (UTC day)
}

function daysBetween(a, b) {
  const ms = 24 * 60 * 60 * 1000;
  return Math.round((new Date(b) - new Date(a)) / ms);
}

export default function useDailyStreak() {
  const [streak, setStreak] = useState(1);

  useEffect(() => {
    const today = todayStr();
    let stored = {};
    try {
      stored = JSON.parse(localStorage.getItem(KEY) || '{}');
    } catch {}

    const last = stored.last_visit;
    const current = Number.isFinite(stored.streak) ? stored.streak : 0;
    let next = current;

    if (!last) {
      next = 1;
    } else if (last === today) {
      next = current || 1;
    } else {
      const gap = daysBetween(last, today);
      next = gap === 1 ? current + 1 : 1;
    }

    localStorage.setItem(KEY, JSON.stringify({ last_visit: today, streak: next }));
    setStreak(next);
  }, []);

  return streak;
}
